import { FiCast, FiCode, FiCpu, FiLayers, FiMonitor, FiServer, FiUsers } from "react-icons/fi";
import React ,{ Component }from "react";

const ServiceList = [
    {
        icon: <FiCode />,
        title: 'Website & Mobiile Development',
        description: 'Design and build core backend and front end'
    },
    {
        icon: <FiServer />,
        title: 'Continuous Integration & Continuous Delivery',
        description: 'Automated builds and tests'
    },
    { 
        icon: <FiCpu />,
        title: 'Testing ',
        description: 'Testing is an important part of any project to keep the bugs away'
    }
]


class ServiceThree extends Component{
    render(){
        const {column} = this.props;
        const ServiceContent = ServiceList.slice(0 , this.props.item);
        
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
                            <a href="#">
                                <div className="service service__style--2">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title">{val.title}</h3>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceThree;
